import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MBSBenefitItem': {
    fontWeight: 500,
  },
  '& .MBSFootnote': {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '150%',
    fontWeight: 500,
    fontStyle: 'italic',
  },
   '& .MBSBenfitItemIcon':{
      flex: '0 0 auto',
      fontSize: theme.spacing(3),
    },
    '& .MBSWrapper':{
      margin: '0 auto',
      maxWidth: 'fit-content',
    }
}));
export default StyledBox;
